import _ from 'lodash';
import PropTypes from 'prop-types';
import { useCallback, useEffect, useState } from 'react';
import constant from '../../../config/constants';
import { withCart } from '../../../utils/CartContext';
import { useRegionComuna } from '../../../utils/hooks';
import { useCurrentDeliveryText } from '../../../utils/hooks/useCurrentDeliveryText';
import { useSelectedDeliveryOption } from '../../../utils/hooks/UseSelectedDeliveryOption';
import noop from '../../../utils/noop';
import { getMetaKey, getSelectedCommuna, getSelectionText, renderOOSView } from '../common';
import { DeliveryOptionsModal } from '../DeliveryOptions/DeliveryOptionsModal';
import DeliveryOptionsSelectedText from '../DeliveryOptions/DeliveryOptionsSelectedText';
import { AvailabilityDesktopStyles } from './AvailabilityDesktop.style';

const {
  AVAILABILITY_OUTOFSTOCK,
  COOKIE_HOME_DELIVERY_KEY,
  COOKIE_STORE_PICKUP_KEY,
  LS_HOME_DELIVERY_KEY,
  LS_STORE_PICKUP_KEY,
  AVAILABILITY_HOMEDELIVERY,
} = constant;

const AvailabilityDesktopItem = ({
  appCtxData,
  availability,
  labelsData,
  isLast,
  hasModal,
  sizes,
  colorVariants,
  cart,
  availabilityList,
  deliveryData,
  deliveryActions,
  selectedType,
  setSelectedType,
  textGenerated,
  deliveryErrors,
  productData,
  variantData,
}) => {
  const { shippingOptionType, stateOfStock } = availability;
  const { currentVariantId, showShippingModal, shippingEstimatedPrice } = productData;
  const { store, selectedZone, isDefaultComuna = false, regionCode } = appCtxData;
  const { isSizeSelected } = cart;

  const { labelsKey, iconsClass } = getMetaKey(shippingOptionType);
  const { inStock } = iconsClass;
  const {
    localStorageComunaKey,
    localStorageRegionKey,
    localStorageCiudadKey,
    localAvailableTextDisplayKey,
    outOfStock,
    subPrefix,
  } = labelsKey;

  const isOutOfStock = stateOfStock === AVAILABILITY_OUTOFSTOCK;

  const [selectedCommuna, setSelectedCommuna] = useState();
  const [modalVisible, setModalVisible] = useState(false);
  // const [variantSelected, setVariantSelected] = useState(false);

  const { selectedDeliveryOption, setSelectedDeliveryOption, zoneConfig, setZoneConfig } = useSelectedDeliveryOption(
    shippingOptionType,
    store,
    selectedZone,
    isDefaultComuna,
    regionCode,
    currentVariantId
  );

  const { comuna, displayText } = useRegionComuna({
    modalVisible,
    lsComunaKey: localStorageComunaKey,
    lsRegionKey: localStorageRegionKey,
    lsCiudadKey: localStorageCiudadKey,
    displayKey: localAvailableTextDisplayKey,
  });

  const currentDeliveryText = useCurrentDeliveryText(
    selectedType,
    availability,
    labelsData,
    outOfStock,
    selectedDeliveryOption
  );

  const comunaName = _.get(zoneConfig, isDefaultComuna ? 'comunaName' : 'name', '');
  const persistedText = textGenerated[shippingOptionType];

  useEffect(() => {
    if (currentDeliveryText && selectedType && selectedDeliveryOption.deliveryOptionType === selectedType) {
      deliveryActions.setTextGenerated((prevTextGenerated) => {
        const currentText = prevTextGenerated[selectedType];
        if (!currentText || JSON.stringify(currentText) !== JSON.stringify(currentDeliveryText)) {
          return {
            ...prevTextGenerated,
            [selectedType]: currentDeliveryText,
          };
        }
        return prevTextGenerated;
      });
    }
  }, [selectedDeliveryOption, selectedType]);

  useEffect(() => {
    setSelectedCommuna(
      getSelectedCommuna({
        shippingOptionType,
        AVAILABILITY_HOMEDELIVERY,
        COOKIE_HOME_DELIVERY_KEY,
        COOKIE_STORE_PICKUP_KEY,
        LS_HOME_DELIVERY_KEY,
        LS_STORE_PICKUP_KEY,
      })
    );
  }, [shippingOptionType]);

  const handleItemClick = useCallback(() => {
    setModalVisible(true);
    setSelectedType(shippingOptionType);
  }, [shippingOptionType, setSelectedType]);

  const getDeliveryModal = useCallback(() => {
    return (
      <DeliveryOptionsModal
        type={shippingOptionType}
        modalVisible={modalVisible}
        setModalVisible={setModalVisible}
        zoneConfig={zoneConfig}
        setZoneConfig={setZoneConfig}
        sizes={sizes}
        colorVariants={colorVariants}
        selectedDeliveryOption={selectedDeliveryOption}
        setSelectedDeliveryOption={setSelectedDeliveryOption}
        isSizeSelected={isSizeSelected}
        selectedType={selectedType}
        setSelectedType={setSelectedType}
        cart={cart}
        availabilityList={availabilityList}
        deliveryData={deliveryData}
        deliveryActions={deliveryActions}
        deliveryErrors={deliveryErrors}
        appCtxData={appCtxData}
        productData={productData}
        variantData={variantData}
        labelsData={labelsData}
      />
    );
  }, [
    shippingOptionType,
    modalVisible,
    setModalVisible,
    zoneConfig,
    setZoneConfig,
    sizes,
    colorVariants,
    selectedDeliveryOption,
    setSelectedDeliveryOption,
    isSizeSelected,
    selectedType,
    setSelectedType,
    cart,
    availabilityList,
    deliveryData,
    deliveryActions,
    deliveryErrors,
    appCtxData,
    productData,
    variantData,
    labelsData,
  ]);
  return (
    <>
      <div>{hasModal && modalVisible && getDeliveryModal()}</div>

      <div
        className={`availability-item ${isLast && 'lastItem'} rebranded`}
        onKeyDown={noop}
        role="button"
        tabIndex={0}
        onClick={handleItemClick}
      >
        <div className={`icon ${inStock}`} />
        <div className={`content ${isOutOfStock ? 'outofstock' : ''}`}>
          {!isOutOfStock
            ? showShippingModal && (
                <>
                  {comuna.name && <span>{labelsData[`${subPrefix}`]} </span>}
                  <div id={`testId-Availability-Desktop-ModalOpen-${shippingOptionType}`}>
                    {persistedText && <DeliveryOptionsSelectedText textData={persistedText} />}
                    <span>
                      {getSelectionText({
                        selectedDeliveryOption,
                        comunaName,
                        labelsData,
                        labelsKey,
                        selectedCommuna,
                        displayText,
                        shippingEstimatedPrice,
                        meatStickers: variantData.meatStickers,
                        shippingOptionType,
                        persistedText,
                      })}
                    </span>
                  </div>
                </>
              )
            : renderOOSView({
                labelsData,
                outOfStock,
                comunaName,
                parentStateName: zoneConfig.parentStateName,
                styles: AvailabilityDesktopStyles,
              })}
        </div>

        <style jsx>{AvailabilityDesktopStyles}</style>
      </div>
    </>
  );
};

AvailabilityDesktopItem.propTypes = {
  availability: PropTypes.object.isRequired,
  labelsData: PropTypes.object.isRequired,
  isLast: PropTypes.bool,
  hasModal: PropTypes.bool,
  sizes: PropTypes.array,
  colorVariants: PropTypes.array,
  cart: PropTypes.object.isRequired,
  availabilityList: PropTypes.array.isRequired,
  deliveryData: PropTypes.object,
  deliveryActions: PropTypes.object.isRequired,
  selectedType: PropTypes.string.isRequired,
  setSelectedType: PropTypes.func.isRequired,
  textGenerated: PropTypes.object.isRequired,
  currentVariantId: PropTypes.string.isRequired,
  showShippingModal: PropTypes.bool.isRequired,
  shippingEstimatedPrice: PropTypes.string.isRequired,
  deliveryErrors: PropTypes.object,
  productData: PropTypes.object.isRequired,
  appCtxData: PropTypes.object.isRequired,
  variantData: PropTypes.object.isRequired,
};

AvailabilityDesktopItem.defaultProps = {
  isLast: false,
  hasModal: true,
  sizes: [],
  colorVariants: [],
  deliveryData: {},
  deliveryErrors: {
    PickupInStore: { isError: false, code: null },
    HomeDelivery: { isError: false, code: null },
    StockInStore: { isError: false, code: null },
  },
};

export default withCart(AvailabilityDesktopItem);
